define('views/components/reseller_contact_card/reseller_contact_card',['require','backbone','marionette','text!templates/components/reseller_contact_card/reseller_contact_card.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');

    var temp = require("text!templates/components/reseller_contact_card/reseller_contact_card.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'div',
        template: _.template(temp)
    });
});
